import { Controller } from "@hotwired/stimulus"

// Tracks the selected tab. Stimulus mirrors the value onto the element as
// data-tabs-selected-value, which the markup can style against. The selected
// tab gets the active class and aria-current.
export default class extends Controller {
  static targets = ["tab"]
  static values = { selected: String }

  select(event) {
    event.preventDefault()
    this.selectedValue = event.params.panel
  }

  selectedValueChanged() {
    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.tabsPanelParam === this.selectedValue
      tab.classList.toggle("active", selected)
      if (selected) tab.setAttribute("aria-current", "true")
      else tab.removeAttribute("aria-current")
    })
  }
}
